const searchBarInput = document.getElementById('search-bar-input');

            searchBarInput.addEventListener('input', function() {
                if (this.value.trim() !== '') {
                    document.body.classList.add('search-active');
                } else {
                    document.body.classList.remove('search-active');
                }
            });
  
const variant= "C"
$('#experience-list option[value="'+variant+'"]').prop('selected', true)
let quickSearchStyle
let quickSearchEnabled
var algoliasearch = algoliaShopify.externals.algoliasearch;
$(".experience-list").change(function(){//to adapt
  Cookies.set("searchExperience",$(".experience-list option:selected").val())
  //reloadpage
  location.reload();

})
if (variant=="A"){
  quickSearchEnabled=true
  quickSearchStyle="tabs"
  $(".algolia-quicksearch-container").addClass("tabs-style")
}else if (variant=="B"){
  quickSearchEnabled=true
  processVariantB()
  $(window).resize(function() {
    processVariantB()
    //reprocess the quick search if displayed because cols style requires to fetch all the indexes. not the case with tabs style
    if (window.customAlgoliaHelpers.quickSearchIsDisplayed)
      processQuickSearch()
  })
}else if (variant=="C"){
  quickSearchEnabled=false
}

function processVariantB(){
  if ($(window).width() >= 768){
    quickSearchStyle="cols"
    $(".algolia-quicksearch-container").removeClass("tabs-style")
    $(".algolia-quicksearch-container").addClass("cols-style")
  }else{
    quickSearchStyle="tabs"
    $(".algolia-quicksearch-container").removeClass("cols-style")
    $(".algolia-quicksearch-container").addClass("tabs-style")
  }
}



window.customAlgoliaHelpers = {};
const searchClient = algoliasearch(
  'TJRHS6K5IH',
  'f62d294de28cccca2719a7d8f72846c9'
);
/*const searchClient = algoliasearch(
  'DUJW1EU3TG',
  'a5ece32a2760614cd76c02ce0b446537'
);
*/
// ---------------------
//
//  Helper functions
//
// ---------------------
function getCurrentStore(){
  //expect to receive an array
  const helper=window.productSearch.helper;
  setTimeout(function(){
    var Result_term = $('#search-bar-input').val();
    var Results = helper.lastResults['nbHits'];
    $('.products-search-summary').find('.search_results_cstm').text('Showing '+Results+ ' results for "' +Result_term+ '"');
  }, 400);
  if (helper && helper.state && helper.state.hierarchicalFacetsRefinements && helper.state.hierarchicalFacetsRefinements.store_availability && helper.state.hierarchicalFacetsRefinements.store_availability.length)
    return window.productSearch.helper.state.hierarchicalFacetsRefinements.store[0]
  else return "Carlton"
}

function getProductPrice(hit){
  // hit.price[0].toString().replace(".",",")
  //const currentStore=getCurrentStore()
  //let index=hit.store.findIndex(el => el==currentStore)
 // if (index==-1)
 //   index=0
 // return  parseFloat(hit.price_array[index]).toFixed(2)
  return parseFloat(hit.price).toFixed(2);
}

function getHeader(title) {
  return `<h5>${title}</h5>`;
}

function getProductLabelByAttribute(attribute) {
  console.log("Attributes: " + attribute);
  switch (attribute) {
    case 'vendor':
      return 'Brands';
    case 'tags':
      return 'Categories';
    case 'categories':
      return 'Categories';
    case "product_type":
      return "Categories"
    default:
      return attribute;
  }
}

const getResetLabel = () => 'Clear my filters';
const renderCollapseButton = () => `
    <svg class="ais-Panel-collapseIcon" width="1em" height="1em" viewBox="0 0 24 24">
      <path d="M5 17.4c.5.5 1.2.5 1.7 0l5.9-5.8 5.8 5.8c.5.5 1.2.5 1.7 0s.5-1.2 0-1.7l-6.6-6.6c-.2-.2-.5-.3-.8-.3-.3 0-.6.1-.8.3l-6.6 6.6c-.7.5-.7 1.3-.3 1.7z" fill='#afafaf'></path>
    </svg>
`;

//Quick search products
const renderQuickSearchProducts = ({ results }) => `
    <ul>
      ${results.hits
        .map(
          hit =>
            `<li>
              <a class="image" href="${hit.page_url}">
                <img src="${(typeof window.getProductPlaceholderImageSrc === 'function' ? window.getProductPlaceholderImageSrc(hit.image_link) : hit.image_link)}">
              </a>
              <a class="title" href="${hit.page_url}">
                <div >${instantsearch.highlight({
                  attribute: 'title',
                  hit,
                  highlightedTagName: 'span',
                })}</div>
              </a>
              <div class="price">${getProductPrice(hit)}</div>
            </li>`
        )
        .join('')}
    </ul>
    <div class="see_allproducts">
        <a href="javascript:void(0)" onclick="window.customAlgoliaHelpers.invokeProcessFullSearch(event)" data-search-type="products" data-search-term="${results.query}" class="btn btn-empty btn-sm">View all products (${
          results.nbHits
        })</a>
    </div>
`;

const renderQuickSearchProductNoHits = () => `
  <div></div>
`;

const renderQuickSearchProductNoInput = () => `
  <div class="row row1">We are all entitled to the best products</div>
  <div class="row row2">Do your research in our departments!</div>
`;

//Quick search recipes
/*const renderQuickSearchRecipeNoHits = () => `
  <div>Aucune recette ne correspond Ã  votre recherche.</div>
`;

const renderQuickSearchRecipes = ({ results }) => `
    <ul>
      ${results.hits
        .map(
          hit =>
            `<li><a href="${hit.link}">${instantsearch.highlight({
              attribute: 'title',
              hit,
            })}</a></li>`
        )
        .join('')}
    </ul>
    <div class="see_allrecipes">
    <a href="javascript:void(0)" onclick="window.customAlgoliaHelpers.invokeProcessFullSearch(event)" data-search-type="recipes" data-search-term="${results.query}" class="btn btn-empty btn-sm">Voir toutes les recettes (${
      results.nbHits
    })</a>
    </div>
`;

const renderQuickSearchRecipeNoInput = () => `
  <div class="row1">On a tous droit aux meilleures recettess</div>
  <div class="row1">Faites votre recherche parmi nos meilleures recettes!</div>
`;
*/
//
const renderQuickSearchQuerySuggestions = ({ results }) => `
    <ul>
      ${results.hits
        .map(
          hit =>
            `<li><a href="javascript:void(0)" onclick='window.customAlgoliaHelpers.invokeProcessFullSearch(event);' data-search-type="products" data-search-term="${hit.query}">${instantsearch.highlight({
              attribute: 'query',
              hit,
            })}</a></li>`
        )
        .join('')}
    </ul>
`;
const renderQuickSearchNoQuerySuggestions = () => `
`;

//quick search articles
/*const renderQuickSearchArticleNoHits = () => `
  <div>Aucun article ne correspond Ã  votre recherche.</div>
`;

const renderQuickSearchArticle = ({ results }) => `
    <ul>
      ${results.hits
        .map(
          hit =>
            `<li><a href="${hit.link}">${instantsearch.highlight({
              attribute: 'title',
              hit,
            })}</a></li>`
        )
        .join('')}
    </ul>
    <div class="see_allarticles">
    <a href="javascript:void(0)" onclick="window.customAlgoliaHelpers.invokeProcessFullSearch(event)" data-search-type="articles" data-search-term="${results.query}" class="btn btn-empty btn-sm">Voir tous les articles (${
      results.nbHits
    })</a>
    </div>
`;

const renderQuickSearchArticleNoInput = () => `
  <div class="row1">On a tous droit aux meilleurs articles</div>
  <div class="row1">Faites votre recherche parmi nos meilleurs articles!</div>
`;
*/
//Stats
const renderStatsText = () => `
No matching results «  »
Showing single result for «  »
Showing  results for «  » 
`;

//full search
const renderMobileFilterSortRowText = () => "Filter or sort"
const renderMobileFilterTabText = () => "Store Filter"
const renderMobileSortTabText = () => "Sort"

const renderRefinementsPanelHeaderText = () => "Store Filters"

//general
//hide the search results page html until a search was submitted
$(".algolia-fullsearch-container").hide()



//fill non-algolia dom elements with text
//mobile flter sort row
$(".mobile-filter-sort-text").html(renderMobileFilterSortRowText())
$(".refinements-modal .filter-tab").html(renderMobileFilterTabText())
$(".refinements-modal .sort-tab").html(renderMobileSortTabText())

//refinement panel

$(".refinements-panel-header-text").html(renderRefinementsPanelHeaderText())

//quick search
const renderQuickSearchProductHeader = () =>"Products"
//const renderQuickSearchRecipeHeader = () =>"Recettes"
//const renderQuickSearchArticleHeader = () =>"Articles"

$(".quicksearch-container .panel .products-header").html(renderQuickSearchProductHeader())
//$(".quicksearch-container .panel .recipes-header").html(renderQuickSearchRecipeHeader())
//$(".quicksearch-container .panel .articles-header").html(renderQuickSearchArticleHeader())

window.customAlgoliaHelpers.invokeProcessFullSearch = (event) => {
  let arg1 = event.target.getAttribute('data-search-type');
  //let arg2 = window.customAlgoliaHelpers.getSearchInputTerm();
  let arg2=event.target.getAttribute('data-search-term');
  window.customAlgoliaHelpers.processFullSearch(arg1,arg2) 
}

window.customAlgoliaHelpers.processFullSearch = function(type,term) {

  if (!term){
    $(".algolia-fullsearch-container").hide()
    return ;
  }
  console.log("+++++"+type);
  if (type=="products"){
    var search=window.productSearch
  }else if (type=="recipes")
    var search=window.recipeSearch
  else if (type=="articles")
    var search=window.articleSearch
  
  if (type=="articles"){
    $('.algolia-fullsearch-container .side-panel').addClass(
      'hide'
    );
    $(".filter-sort-row").addClass("hide")
  }else{
    $('.algolia-fullsearch-container .side-panel').removeClass(
      'hide'
    );
    $(".filter-sort-row").removeClass("hide")
  }

  if (!search.started) search.start();

  if(type=="products"){
 /*   let store=getCurrentStore()
    search.helper
    .setQuery(term)
    .clearRefinements()
    .addHierarchicalFacetRefinement("store_availability",store)
    .search();
  }else{ */
    search.helper
    .setQuery(term)
    .clearRefinements()
    .search();
  }


  $('.algolia-fullsearch-container .search-summary').removeClass(
    'is-displayed'
  );
//  $('.algolia-fullsearch-container .refinements').removeClass('is-displayed');
  $('.algolia-fullsearch-container .results').removeClass('is-displayed');

  $('.algolia-fullsearch-container .'+type+'-search-summary').addClass(
    'is-displayed'
  );
  $('.algolia-fullsearch-container .'+type+'-refinements').addClass(
    'is-displayed'
  );
  $('.algolia-fullsearch-container .'+type+'-results').addClass('is-displayed');

  $('.search-type-tab').removeClass('is-active');
  $('.'+type+'-search-type-tab').addClass('is-active');

  //unhide if was hidden because of no results
  $(".algolia-fullsearch-container").show()
  window.customAlgoliaHelpers.hideQuicksearch();
}

function changeQuickSearchActiveTab(tabType){
  $('.algolia-quicksearch-container .search-type-tab').removeClass(
    'is-active'
  );
  $('.algolia-quicksearch-container .search-type-tab[data-tab-type="'+tabType+'"]').addClass(
    'is-active'
  );

}

function displayQuickSearchPanels(panels){
  $('.algolia-quicksearch-container .panel').removeClass('is-displayed');

  panels.forEach(function(panel){
    $('.algolia-quicksearch-container [data-container-type="'+panel+'"]').addClass(
      'is-displayed'
    );
  })
}

function renderQuickSearchProductPanel(results) {
   //resets all divs
  $('.products-panel .products-text').html("")
  $('.products-panel .products-results').html("")
  $('.products-panel .products-suggestions').html("")

  if ($("input").val().length==0){
    $('.products-panel .products-text').html(
      renderQuickSearchProductNoInput()
    );
     
  }else{
      if (results[0].hits.length) {
        $('.products-panel .products-results').html(
          renderQuickSearchProducts({ results: results[0] })
        );
      } else {
        $('.products-panel .products-text').html(renderQuickSearchProductNoHits);
      }
  
      if (results[1].hits.length) {
        $('.products-panel .products-suggestions').html(
          renderQuickSearchQuerySuggestions({ results: results[1] })
        );
      } else {
        $('.products-panel .products-text').html(renderQuickSearchNoQuerySuggestions);
      }
  }
}

/*function renderQuickSearchRecipePanel(results) {
  //resets all divs
  $('.recipes-panel .recipes-text').html("")
  $('.recipes-panel .recipes-results').html("")
  if ($("input").val().length==0){
    $('.recipes-panel .recipes-text').html(
      renderQuickSearchRecipeNoInput()
    );
  }else{
      if (results[0].hits.length) {
        $('.recipes-panel .recipes-results').html(
          renderQuickSearchRecipes({ results: results[0] })
        );
      } else {
        $('.recipes-panel .recipes-text').html(renderQuickSearchRecipeNoHits);
      }      
  }

}


function renderQuickSearchArticlePanel(results) {
  //resets all divs
  $('.articles-panel .articles-text').html("")
  $('.articles-panel .articles-results').html("")
  if ($("input").val().length==0){
    $('.articles-panel .articles-text').html(
      renderQuickSearchArticleNoInput()
    );
  }else{
      if (results[0].hits.length) {
        $('.articles-panel .articles-results').html(
          renderQuickSearchArticle({ results: results[0] })
        );
      } else {
        $('.articles-panel .articles-text').html(renderQuickSearchArticleNoHits);
      }
      
  }

}
*/

function getActiveQuickSearchTab(){
  return $(".algolia-quicksearch-container .search-type-tab.is-active").attr("data-tab-type")
}

function getActiveFullSearchTab(){
  return $(".algolia-fullsearch-container .search-type-tab.is-active").attr("data-tab-type")
}

window.customAlgoliaHelpers.showQuicksearch = function() {
  $('.algolia-quicksearch-container').addClass('is-displayed');
  window.customAlgoliaHelpers.quickSearchIsDisplayed=true
};
window.customAlgoliaHelpers.hideQuicksearch = function() {
  $('.algolia-quicksearch-container').removeClass('is-displayed');
  window.customAlgoliaHelpers.quickSearchIsDisplayed=false
};
window.customAlgoliaHelpers.getSearchInputTerm = function() {
  return $('#search-bar-input').val();
};

// on startup
//window.customAlgoliaHelpers.hideQuicksearch();

$('#search-bar-input').on('click', function() {
  //if (window.window.customAlgoliaHelpers.getSearchInputTerm())
  if (quickSearchEnabled)
    processQuickSearch()
});

//hide quick search if click outside of search zone
$(document).mousedown(function(e) {
  var container = $('#search-form');
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    $('.algolia-quicksearch-container').removeClass('is-displayed');
  }
});

//hide if close button is clicked
$('.quicksearch-container .close-button').on('click', function() {
  $('.algolia-quicksearch-container').removeClass('is-displayed');
});

function processQuickSearch(){
    // Do something
    term=$('#search-bar input').val()
    const queries = [
      {
        indexName: 'aone_products',
        query: term,
        params: {
          hitsPerPage: 5,
        },
      },
      {
        indexName: 'products_query_suggestions',
        query: term,
        params: {
          hitsPerPage: 5,
        },
      }
      
    ];

    if(quickSearchStyle=="tabs"){
      currentlySelectedTab=getActiveQuickSearchTab()
      if (currentlySelectedTab=="products"){
        searchClient.search([queries[0],queries[1]], (err, { results } = {}) => {
          if (err) throw err;
          renderQuickSearchProductPanel(results)
        })
        displayQuickSearchPanels(["products"])
      }
    }else{
      searchClient.search(queries, (err, { results } = {}) => {
        if (err) throw err;
        renderQuickSearchProductPanel([results[0],results[1]])
     //   renderQuickSearchRecipePanel([results[2]])
     //   renderQuickSearchArticlePanel([results[3]])  
        displayQuickSearchPanels(["products","recipes","articles"])
      })  
    }
    window.customAlgoliaHelpers.showQuicksearch()
}
$('#search-bar input').on('keyup', function(e) {
  var checkterm = $(this).val().length;
  if( checkterm >= 1){
    $('.groceries-block_icon').css('display','none');
  }else{
    $('.groceries-block_icon').css('display','block');
  }
  if (e.keyCode !== 13) {
    if (quickSearchEnabled){
      processQuickSearch();
    }
    else{
      let term = window.customAlgoliaHelpers.getSearchInputTerm();
      let type=getActiveFullSearchTab() || "products"
      window.customAlgoliaHelpers.currentTerm = term;
      window.customAlgoliaHelpers.processFullSearch(type,term);
    }
      
  }
});

$('#search-form').submit(function(event) {
  event.preventDefault();
  // show normal page results
  currentlySelectedTab=getActiveQuickSearchTab()
  const term = window.customAlgoliaHelpers.getSearchInputTerm();
  window.customAlgoliaHelpers.processFullSearch(type=currentlySelectedTab,term);
  window.customAlgoliaHelpers.currentTerm = term;
  $('.groceries-block_icon').css('display','none');
});

$('.algolia-fullsearch-container .search-type-tab').click(function(event) {
  const term = window.customAlgoliaHelpers.currentTerm;
  const type=$(event.currentTarget).attr("data-search-type-tab")
  window.customAlgoliaHelpers.processFullSearch(type,term);
});

$('.algolia-quicksearch-container .search-type-tab').click(function(event) {
  changeQuickSearchActiveTab($(event.currentTarget).attr("data-tab-type"))
  processQuickSearch()
});

// Get the <span> element that closes the modal
var span = document.getElementsByClassName("close")[0];

// When the user clicks on the button, open the modal
$(".filter-sort-row").click(function() {
  $(".side-panel").addClass("modal")
  $(".side-panel .content").addClass("modal-content")
})

$(".close-button").click(function() {
  $(".side-panel").removeClass("modal")
  $(".side-panel .content").removeClass("modal-content")
})


// When the user clicks anywhere outside of the modal, close it
/*
window.onclick = function(event) {
  if (event.target == modal) {
    modal.style.display = "none";
  }
}
*/

/* Product Search */

window.productSearch = instantsearch({
  indexName: 'aone_products',
  searchClient: searchClient,
  searchParameters: {
    attributesToSnippet: ['title:10'],
    snippetEllipsisText: ' [...]',
  },
});
const categoryPanel = instantsearch.widgets.panel({
  collapsed: ({ state }) => {
    return false;
  },
  templates: {
    header: getHeader(getProductLabelByAttribute('categories')),
    collapseButtonText: renderCollapseButton(),
  },
  hidden(options) {
    return options.results.nbHits === 0;
  },
})(instantsearch.widgets.menu);


const categoryPanelModal = instantsearch.widgets.panel({
  collapsed: ({ state }) => {
    return false;
  },
  templates: {
    header: getHeader(getProductLabelByAttribute('categories')),
    header: getHeader(),
    collapseButtonText: renderCollapseButton(),
  },
  hidden(options) {
    return options.results.nbHits === 0;
  },

})(instantsearch.widgets.menu);


const brandPanel = instantsearch.widgets.panel({
  collapsed: ({ state }) => {
    return false;
  },
  templates: {
    header: getHeader(getProductLabelByAttribute('vendor')),
    collapseButtonText: renderCollapseButton(),
  },
  hidden(options) {
    return options.results.nbHits === 0;
  },
})(instantsearch.widgets.refinementList);

const brandPanelModal = instantsearch.widgets.panel({
  collapsed: ({ state }) => {
    return false;
  },
  templates: {
    header: getHeader(getProductLabelByAttribute('vendor')),
    collapseButtonText: renderCollapseButton(),
  },
  hidden(options) {
    return options.results.nbHits === 0;
  },
})(instantsearch.widgets.refinementList);


window.productSearch.addWidget(
  instantsearch.widgets.stats({
    container: '.algolia-fullsearch-container .products-search-summary .stats',
    templates: {
      text: renderStatsText(),
    },
  })
);

//main refinement panel

window.productSearch.addWidget(
  instantsearch.widgets.currentRefinements({
    container:
      '.algolia-fullsearch-container .products-search-summary .current-refinements',
    transformItems(items) {
      
      jQuery.getJSON('/cart.js', function(cart) {
         //alert("dd");
        for(var i=0; i<cart.items.length; i++){
          var item = cart.items[i];
          var itemId = item.id;
          var itemQty = item.quantity;
          $(".plus_minus-box[productid="+ itemId +"]").css('display','flex');
          $(".cart-button_box[productid="+ itemId +"]").hide();
          $(".quantity[productid="+ itemId +"]").val(itemQty).attr('disabled',true);
          showCartLabel(itemId,itemQty);
        }
      });
      
      var items = items.map(function(item) {
        item.label = getProductLabelByAttribute(item.label );
        return item;
      });
      return items;
    },
    excludedAttributes:["store_availability","query"]
  })
);

window.productSearch.addWidget(
  instantsearch.widgets.clearRefinements({
    container:
      '.algolia-fullsearch-container .products-search-summary .clear-refinements',
    templates: {
      resetLabel: getResetLabel(),
    },
  })
);


/*
window.productSearch.addWidget(
  instantsearch.widgets.sortBy({
    container: '#sort-by',
    items: [
      { label: 'Featured', value: 'instant_search' },
      { label: 'Price (asc)', value: 'instant_search_price_asc' },
      { label: 'Price (desc)', value: 'instant_search_price_desc' },
    ],
  })
);
*/
window.productSearch.addWidget(
  instantsearch.widgets.menuSelect({
    container: '.algolia-fullsearch-container .refinements-panel .products-refinements .store',
    attribute: 'store',
  })
)

window.productSearch.addWidget(
  brandPanel({
    container: '.algolia-fullsearch-container .refinements-panel .products-refinements .brand',
    attribute: 'vendor',
    //sortBy: ['isRefined', 'count:desc', 'name:asc'],
    operator: 'or',
    showMore: {
      limit: 20,
    },
    searchable: true,
    searchablePlaceHolder: 'Brands...',
    searchableIsAlwaysActive: false,
    templates: {
      searchableNoResults: '<div class="sffv_no-results">No results</div>',
    },
  })
);


/*

window.productSearch.addWidget(
  brandPanelModal({
    container: '.algolia-fullsearch-container .refinements-modal .products-refinements .brand',
    attribute: 'brand',
    //sortBy: ['isRefined', 'count:desc', 'name:asc'],
    operator: 'or',
    showMore: {
      limit: 10,
    },
    searchable: false,
    searchablePlaceHolder: 'Marques...',
    searchableIsAlwaysActive: false,
    templates: {
      searchableNoResults: '<div class="sffv_no-results">Aucun rÃ©sultat</div>',
    },
  })
);



window.productSearch.addWidget(
  instantsearch.widgets.rangeSlider({
    container: '.algolia-fullsearch-container .products-refinements .price-slider',
    attribute: 'price',
  })
);
*/
window.productSearch.addWidget(
  categoryPanel({
    container:
      '.algolia-fullsearch-container .refinements-panel .products-refinements .category',
    attribute: "tags",
    sortBy:["isRefined","count:desc"],
  })
);
/*
window.productSearch.addWidget(
  categoryPanelModal({
    container: '.algolia-fullsearch-container .refinements-modal .products-refinements .category',
    attribute: 'categories',
    limit: 10,
    showMore: true,
    showMoreLimit:20,
    sortBy: ["isRefined", "count:desc"],
  })
);
*/
window.productSearch.addWidget(
  instantsearch.widgets.hits({
    container: '.algolia-fullsearch-container .products-results  .hits',
    templates: {
      item(hit) {
        return `
<div class="product-item">
<div class="item_image-title" page-url="/products/${hit.handle}">
  <div class="product-item-image">
<a href="/products/${hit.handle}">
      <img src="${(typeof window.getProductPlaceholderImageSrc === 'function' ? window.getProductPlaceholderImageSrc(hit.product_image) : hit.product_image)}" align="left" alt="${hit.title}" />
    </a>
<div class="add-to-cart-btn pa" productid="${hit.objectID}" style="display: none"> 
  <span class="added-to-cart"><span class="pr_wrap_qty"></span> in Cart</span>
</div>
  </div>
  <div class="product-item-text">
    <div class="product-item-highlight">
    </div>   
    <div class="search-vendor"><span> ${hit.vendor}</span> </div>
    <div class="product-item-title">
    <a href="/products/${hit.handle}" data-product-id="${hit.objectID}">    
        ${instantsearch.highlight({
          attribute: 'title',
          highlightedTagName: 'mark',
          hit,
        })}
      </a>
    </div>      
    <div class="product-item-packaging">
    </div>   
    <div class="product-item-perunit">
    </div>   
  </div>
</div>
  <div class="product-item-badges">
  </div>   
  <div class="product-item-promotion">
  </div>   
    <div class="product-item-price">
      $<span>${getProductPrice(hit)}</span>
    </div>   
    <div class="product-item-cta"  variant-id="${hit.objectID}" page-url="/products/${hit.handle}">
	  
		<div class="add_quantity-box">
		<div class="plus_minus-box" productid="${hit.objectID}">
			<span class="cart-minus cart-change-quantity" data-func="minus" productid="${hit.objectID}">
			  <span class="icon-minus"></span>
			</span> 
           <div class="cart-input_box">
		<input type="number" min="1" max="10" class="quantity" value="1" productid="${hit.objectID}" oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1');" />
	  </div>
			<span class="cart-plus cart-change-quantity" data-func="plus" productid="${hit.objectID}">
			  <span class="icon-plus"></span>
			</span>
		</div> 
      <div class="cart-button_box" productid="${hit.objectID}">
		<button id="algo_search-cart" type="button" class="js-add btn " value="Add" product-id="${hit.objectID}">Add to cart</button>
	  </div> 
	  </div>
    </div>   
</div>   
      `;
        
      },
    },
    transformItems(items) {
      return items.filter(function(item){
        return !/saumon/i.test(item.title)
        //return true  //this is for testing
      });
    },
  })
);

window.productSearch.addWidget(
  instantsearch.widgets.pagination({
    container: '.algolia-fullsearch-container .products-results .pagination',
  })
);

// search.start();

/* Recipe Search */
/*
const occasionPanel = instantsearch.widgets.panel({
  collapsed: ({ state }) => {
    //return state.query.length === 0;
    return true;
  },
  templates: {
    header: getHeader('Occasion'),
    collapseButtonText: renderCollapseButton(),
  },
  hidden(options) {
    return options.results.nbHits === 0;
  },
})(instantsearch.widgets.refinementList);

const cuisinePanel = instantsearch.widgets.panel({
  collapsed: ({ state }) => {
    //return state.query.length === 0;
    return true;
  },
  templates: {
    header: getHeader('Cuisine'),
    collapseButtonText: renderCollapseButton(),
  },
  hidden(options) {
    return options.results.nbHits === 0;
  },
})(instantsearch.widgets.refinementList);

const coursePanel = instantsearch.widgets.panel({
  collapsed: ({ state }) => {
    //return state.query.length === 0;
    return true;
  },
  templates: {
    header: getHeader('Type de plat'),
    collapseButtonText: renderCollapseButton(),
  },
  hidden(options) {
    return options.results.nbHits === 0;
  },
})(instantsearch.widgets.refinementList);

const dishTypePanel = instantsearch.widgets.panel({
  collapsed: ({ state }) => {
    //return state.query.length === 0;
    return true;
  },
  templates: {
    header: getHeader('Plat'),
    collapseButtonText: renderCollapseButton(),
  },
  hidden(options) {
    return options.results.nbHits === 0;
  },
})(instantsearch.widgets.refinementList);

const dietPanel = instantsearch.widgets.panel({
  collapsed: ({ state }) => {
    //return state.query.length === 0;
    return true;
  },
  templates: {
    header: getHeader('RÃ©gime'),
    collapseButtonText: renderCollapseButton(),
  },
  hidden(options) {
    return options.results.nbHits === 0;
  },
})(instantsearch.widgets.refinementList);

const costPanel = instantsearch.widgets.panel({
  collapsed: ({ state }) => {
    //return state.query.length === 0;
    return true;
  },
  templates: {
    header: getHeader('Budget'),
    collapseButtonText: renderCollapseButton(),
  },
  hidden(options) {
    return options.results.nbHits === 0;
  },
})(instantsearch.widgets.refinementList);

const difficultyPanel = instantsearch.widgets.panel({
  collapsed: ({ state }) => {
    //return state.query.length === 0;
    return true;
  },
  templates: {
    header: getHeader('DifficultÃ©'),
    collapseButtonText: renderCollapseButton(),
  },
  hidden(options) {
    return options.results.nbHits === 0;
  },
})(instantsearch.widgets.refinementList);

const preparationTimePanel = instantsearch.widgets.panel({
  collapsed: ({ state }) => {
    return true;
  },
  templates: {
    header: getHeader('Temps de preparation'),
    collapseButtonText: renderCollapseButton(),
  },
  hidden(options) {
    return options.results.nbHits === 0;
  },
})(instantsearch.widgets.rangeSlider);

const cookingTimePanel = instantsearch.widgets.panel({
  collapsed: ({ state }) => {
    return true;
  },
  templates: {
    header: getHeader('Temps de cuisson'),
    collapseButtonText: renderCollapseButton(),
  },
  hidden(options) {
    return options.results.nbHits === 0;
  },
})(instantsearch.widgets.rangeSlider);

window.recipeSearch = instantsearch({
  indexName: 'recipes_fr',
  searchClient: searchClient,
  searchParameters: {
    attributesToSnippet: ['title:10'],
    snippetEllipsisText: ' [...]',
  },
});

window.recipeSearch.addWidget(
  instantsearch.widgets.currentRefinements({
    container:
      '.algolia-fullsearch-container .recipes-search-summary .current-refinements',
  })
);

window.recipeSearch.addWidget(
  instantsearch.widgets.clearRefinements({
    container:
      '.algolia-fullsearch-container .recipes-search-summary .clear-refinements',
    templates: {
      resetLabel: getResetLabel(),
    },
  })
);

window.recipeSearch.addWidget(
  instantsearch.widgets.stats({
    container: '.algolia-fullsearch-container .recipes-search-summary .stats',
    templates: {
      text: renderStatsText(),
    },
  })
);

window.articleSearch = instantsearch({
  indexName: 'articles_fr',
  searchClient: searchClient,
  searchParameters: {
    attributesToSnippet: ['title:10'],
    snippetEllipsisText: ' [...]',
  },
});

window.articleSearch.addWidget(
  instantsearch.widgets.stats({
    container: '.algolia-fullsearch-container .articles-search-summary .stats',
    templates: {
      text: renderStatsText(),
    },
  })
);


window.recipeSearch.addWidget(
  instantsearch.widgets.sortBy({
    container: '#sort-by',
    items: [
      { label: 'Featured', value: 'instant_search' },
      { label: 'Price (asc)', value: 'instant_search_price_asc' },
      { label: 'Price (desc)', value: 'instant_search_price_desc' },
    ],
  })
);


window.recipeSearch.addWidget(
  occasionPanel({
    container: '.algolia-fullsearch-container .refinements-panel .recipes-refinements .occasion',
    attribute: 'occasion',
    //sortBy: ['isRefined', 'count:desc', 'name:asc'],
    operator: 'or',
    searchable: false,
    searchablePlaceHolder: 'Marques...',
    searchableIsAlwaysActive: false,
    templates: {
      searchableNoResults: '<div class="sffv_no-results">Aucun rÃ©sultat</div>',
    },
  })
);


window.recipeSearch.addWidget(
  cuisinePanel({
    container: '.algolia-fullsearch-container .recipes-refinements .cuisine',
    attribute: 'type-cuisine',
    //sortBy: ['isRefined', 'count:desc', 'name:asc'],
    operator: 'or',
    searchable: false,
    searchablePlaceHolder: 'Marques...',
    searchableIsAlwaysActive: false,
    templates: {
      searchableNoResults: '<div class="sffv_no-results">Aucun rÃ©sultat</div>',
    },
  })
);

window.recipeSearch.addWidget(
  coursePanel({
    container: '.algolia-fullsearch-container .recipes-refinements .course',
    attribute: 'type-course',
    //sortBy: ['isRefined', 'count:desc', 'name:asc'],
    operator: 'or',
    searchable: false,
    searchablePlaceHolder: 'Marques...',
    searchableIsAlwaysActive: false,
    templates: {
      searchableNoResults: '<div class="sffv_no-results">Aucun rÃ©sultat</div>',
    },
  })
);

window.recipeSearch.addWidget(
  dishTypePanel({
    container: '.algolia-fullsearch-container .recipes-refinements .dish-type',
    attribute: 'type-plat',
    //sortBy: ['isRefined', 'count:desc', 'name:asc'],
    operator: 'or',
    searchable: false,
    searchablePlaceHolder: 'Marques...',
    searchableIsAlwaysActive: false,
    templates: {
      searchableNoResults: '<div class="sffv_no-results">Aucun rÃ©sultat</div>',
    },
  })
);

window.recipeSearch.addWidget(
  dietPanel({
    container: '.algolia-fullsearch-container .recipes-refinements .diet',
    attribute: 'dietetique',
    //sortBy: ['isRefined', 'count:desc', 'name:asc'],
    operator: 'or',
    searchable: false,
    searchablePlaceHolder: 'Marques...',
    searchableIsAlwaysActive: false,
    templates: {
      searchableNoResults: '<div class="sffv_no-results">Aucun rÃ©sultat</div>',
    },
  })
);

window.recipeSearch.addWidget(
  difficultyPanel({
    container: '.algolia-fullsearch-container .recipes-refinements .difficulty',
    attribute: 'difficulty',
    //sortBy: ['isRefined', 'count:desc', 'name:asc'],
    operator: 'or',
    searchable: false,
    searchablePlaceHolder: 'Marques...',
    searchableIsAlwaysActive: false,
    templates: {
      searchableNoResults: '<div class="sffv_no-results">Aucun rÃ©sultat</div>',
    },
  })
);

window.recipeSearch.addWidget(
  costPanel({
    container: '.algolia-fullsearch-container .recipes-refinements .cost',
    attribute: 'cost',
    //sortBy: ['isRefined', 'count:desc', 'name:asc'],
    operator: 'or',
    /*  cannot make it work to transform the integer into â‚¬ signs
    transformItems(items) {
      return items.map(function(item) {
        if (item.value == 1) item.label = 'â‚¬';
        else if (item.value == 2) item.label = 'â‚¬â‚¬';
        else if (item.value == 3) item.label = 'â‚¬â‚¬â‚¬';
        console.log(item)
        return item;
      });
    },
    templates: {
      item: `
      <label class="ais-RefinementList-label"> <input type="checkbox" class="ais-RefinementList-checkbox" value=""> <span class="ais-RefinementList-labelText"></span> <span class="ais-RefinementList-count"></span> </label>
      `,
    
    },
    
  })
);

window.recipeSearch.addWidget(
  cookingTimePanel({
    container:
      '.algolia-fullsearch-container .recipes-refinements .cooking-time',
    attribute: 'cooking-time',
    operator: 'or',
  })
);

window.recipeSearch.addWidget(
  preparationTimePanel({
    container:
      '.algolia-fullsearch-container .recipes-refinements .preparation-time',
    attribute: 'preparation-time',
    operator: 'or',
  })
);


/*
window.recipeSearch.addWidget(
  categoryPanel({
    container: '.algolia-fullsearch-container .category',
    attribute: 'product_type',
  })
);

window.recipeSearch.addWidget(
  instantsearch.widgets.rangeSlider({
    container: '.algolia-fullsearch-container .price-slider',
    attribute: 'price',
  })
);


window.recipeSearch.addWidget(
  instantsearch.widgets.hits({
    container: '.algolia-fullsearch-container .recipes-results .hits',
    templates: {
      item(hit) {
        return `
<div class="recipe-item">
  <div class="recipe-item-image">
    <a href="${hit.link}">
      <img src="${hit['image-link']}" align="left" alt="" />
    </a>
  </div>
  <div class="recipe-item-text">  
    <div class="recipe-item-title">
       <a href="${hit.link}">    
         ${instantsearch.highlight({
           attribute: 'title',
           highlightedTagName: 'mark',
           hit,
         })}
       </a>
     </div>      
   </div>
</div>   
      `;
      },
    },
    transformItems(items) {
      return items.filter(function(item){
        //return !!/saumon/i.test(item.title)
        return true  //this is for testing
      });
    },
  })
);

window.recipeSearch.addWidget(
  instantsearch.widgets.pagination({
    container: '.algolia-fullsearch-container .recipes-results .pagination',
  })
);

// search.start();

window.articleSearch.addWidget(
  instantsearch.widgets.hits({
    container: '.algolia-fullsearch-container .articles-results .hits',
    templates: {
      item(hit) {
        return `
<div class="article-item">
  <div class="article-item-image">
    <a href="${hit.link}">
      <img src="${hit['image-link']}" align="left" alt="" />
    </a>
  </div>
  <div class="article-item-text">  
    <div class="article-item-title">
      <h5>
       <a href="${hit.link}">    
         ${instantsearch.highlight({
           attribute: 'title',
           highlightedTagName: 'mark',
           hit,
         })}
       </a>
      </h5>
     </div>
     <div class="article-item-description">    
      <a href="${hit.link}"> 
        <p>
        ${instantsearch.highlight({
          attribute: 'description',
          highlightedTagName: 'mark',
          hit,
        })}
        </p>
      </a>
     </div>  
   </div>
</div>   
      `;
      },
    },
  })
);

window.articleSearch.addWidget(
  instantsearch.widgets.pagination({
    container: '.algolia-fullsearch-container .articles-results .pagination',
  })
);
*/

